import { Component, Input } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';

@Component({
  selector: 'app-no-data',
  imports: [CommonModule, NgOptimizedImage],
  templateUrl: './no-data.component.html',
  styleUrl: './no-data.component.scss',
})
export class NoDataComponent {
  @Input() title: string = 'No data available';
  @Input() message: string = 'Please wait while the data is being loaded or check back later';
}
